"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Ruleset = void 0;
const BooleanRule_1 = require("./BooleanRule");
const ComparisonRule_1 = require("./ComparisonRule");
const MetricRule_1 = require("./MetricRule");
const ModelCommon_1 = require("./ModelCommon");
const typeName = 'Ruleset';
class Ruleset extends ModelCommon_1.ModelCommon {
    /**
     * Currently, can't inherit from `Thing`, as the constructor just expects `ob`
     * A consequence of `can't use prototype.constructor.name in Webpack`
     */
    constructor(ob) {
        super(typeName, ob);
        this.definition = {
            BooleanRule: [],
            MetricRule: [],
            ComparisonRule: [],
        };
        /** CRA — 2025 05: Possible deprecatable? */
        this.Group = ob.Group ?? undefined;
        this.global = ob.global ?? false;
        this.definition = ob.definition ?? {
            BooleanRule: [],
            MetricRule: [],
            ComparisonRule: [],
        };
        if (!this.definition.BooleanRule)
            this.definition.BooleanRule = [];
        if (!this.definition.MetricRule)
            this.definition.MetricRule = [];
        if (!this.definition.ComparisonRule)
            this.definition.ComparisonRule = [];
        if (this.definition.GeofenceRule)
            delete this.definition.GeofenceRule;
        if (this.definition.BooleanRule)
            this.definition.BooleanRule = this.definition.BooleanRule.map((r) => new BooleanRule_1.BooleanRule({ ...r, type: BooleanRule_1.BooleanRuleClassName }));
        if (this.definition.MetricRule)
            this.definition.MetricRule = this.definition.MetricRule.map((r) => new MetricRule_1.MetricRule({ ...r, type: MetricRule_1.MetricRuleClassName }));
        if (this.definition.ComparisonRule)
            this.definition.ComparisonRule = this.definition.ComparisonRule.map((r) => new ComparisonRule_1.ComparisonRule({ ...r, type: ComparisonRule_1.ComparisonRuleClassName }));
        this.globallyApplyToObjectTypeId = ob.globallyApplyToObjectTypeId ?? false;
        this.validBetween = ob.validBetween;
        this.appliesToType = ob.appliesToType ?? undefined;
        this.setOperation = ob.setOperation;
        this.messageTemplate = ob.messageTemplate;
        this.escalationTemplate = ob.escalationTemplate;
        this.period = ob.period;
        this.unit = ob.unit;
    }
    getUserAttributes() {
        return {
            ...super.getUserAttributes(),
            appliesToType: {
                type: 'String',
                label: 'Applies to type',
                editable: true,
            },
            globallyApplyToObjectTypeId: {
                type: 'Boolean',
                label: 'Always Apply To Type',
                editable: true,
            },
        };
    }
}
exports.Ruleset = Ruleset;
